module.exports = __webpack_public_path__ + "img/Medical.16fc3163.png";